import { render, staticRenderFns } from "./BtnConfirmarFormCarga.vue?vue&type=template&id=0ef18899&"
import script from "./BtnConfirmarFormCarga.vue?vue&type=script&lang=js&"
export * from "./BtnConfirmarFormCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports